import React, { useState } from 'react';
import IconsMapper from 'common/components/IconsMapper/IconsMapper';
import { AsYouType } from 'libphonenumber-js';
import TrackingService from 'common/services/Tracking/Tracking';
import { SimpleCta } from '../SimpleCard/SimpleCard';
import './Phone.css';

const Phone = ({ merchant }) => {
  const [displayPhone, setDisplayPhone] = useState(false);

  if (!merchant.phone) {
    return null;
  }

  const icon = 'faPhone';

  const phoneNumber = new AsYouType().input(merchant.phone);

  const onDisplayPhone = (e) => {
    e.preventDefault();
    TrackingService.trackClickToCall(merchant.id, 'real');
    setDisplayPhone(true);
  };

  return (
    <>
      <a
        className="desktop-only sl-text-bold sl-flex sl-ai-center sl-jc-center"
        href={`tel:${phoneNumber}`}
        rel="nofollow noopener noreferrer"
        itemProp="telephone"
        aria-label={`Appeler le salon au ${phoneNumber}`}
        style={{ fontSize: '18px' }}
      >
        <IconsMapper icon={icon} /> {phoneNumber}
      </a>
      <div className="mobile-only-flex sl-grow-1">
        {displayPhone ? (
          <SimpleCta
            style={{ flexGrow: 1 }}
            url={`tel:${merchant.phone}`}
            itemProp="telephone"
          >
            {phoneNumber}
          </SimpleCta>
        ) : (
          <SimpleCta
            icon={icon}
            style={{ flexGrow: 1 }}
            url={`tel:${merchant.phone}`}
            onClick={onDisplayPhone}
          >
            APPELER
          </SimpleCta>
        )}
      </div>
    </>
  );
};

export default Phone;
